module.exports = __webpack_public_path__ + "static/img/BA.33725ece.svg";